const UserValidationHook = () => {
  const nameRegex = /^[A-Za-z. ]+$/;
  const emailRegex =
    /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

  const textRegex = /^[A-Za-z0-9.,&''"()\-\/ ]+$/;

  const mobileRegex = /^\d{10,15}$/;

  const validateFirstName = (firstname) => {
    const value = firstname?.trim();

    if (!value) {
      return "Please enter your firstname";
    }

    if (!nameRegex.test(value)) {
      return "Invalid firstname !";
    }

    return "";
  };

  const validateLastName = (lastname) => {
    const value = lastname?.trim();

    if (value && !nameRegex.test(value)) {
      return "Invalid lastname !";
    }

    return "";
  };

  const validateEmail = (email) => {
    const value = email?.trim();

    if (!value) {
      return "Email is required";
    }

    if (!emailRegex.test(value)) {
      return "You have entered an invalid email !";
    }

    return "";
  };

  const validateMobile = (mobile) => {
    const value = mobile?.toString().trim();

    if (!value) {
      return "Contact number is required";
    }

    if (!mobileRegex.test(value)) {
      return "Enter a valid mobile number";
    }

    return "";
  };

  const validateCollege = (college) => {
    const value = college?.trim();

    if (value && !textRegex.test(value)) {
      return "You have entered invalid college name !";
    }

    return "";
  };

  const validateBranch = (branch) => {
    const value = branch?.trim();

    if (value && !textRegex.test(value)) {
      return "You have entered invalid branch name !";
    }

    return "";
  };

  const validateUserForm = ({
    firstname,
    lastname,
    email,
    mobile,
    college,
    branch,
  }) => {
    return (
      validateFirstName(firstname) ||
      validateLastName(lastname) ||
      validateEmail(email) ||
      validateMobile(mobile) ||
      validateCollege(college) ||
      validateBranch(branch)
    );
  };

  return {
    validateFirstName,
    validateLastName,
    validateEmail,
    validateMobile,
    validateCollege,
    validateBranch,
    validateUserForm,
  };
};

export default UserValidationHook;